import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import './CompanyAutoComplete.css';

class TemplateAutoComplete extends Component {
  constructor(props) {
    super(props);
    const searchTerm = props.searchTerm || '';
    this.state = {
      searchTerm,
      suggestions: this.filterTemplates(searchTerm),
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchTerm !== prevProps.searchTerm) {
      this.setState({ searchTerm: this.props.searchTerm || '' });
    }
  }

  filterTemplates = value => {
    const inputValue = value.trim().toLowerCase();
    const { templates } = this.props;
    return templates.filter(template => {
      return template.templateName.toLowerCase().includes(inputValue);
    });
  };

  getTemplateValue = template => template.templateName;

  renderSuggestion = template => <div>{template.templateName}</div>;

  onChange = (event, { newValue }) => {
    if (newValue === '') {
      this.props.onChange({ name: 'template', value: null, suggestion: null });
    }
    this.setState({
      searchTerm: newValue,
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.filterTemplates(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  onTemplateSelected = (ev, { suggestion, suggestionValue }) => {
    const evObj = { name: 'template', value: suggestionValue, suggestion };
    this.props.onChange(evObj);
  };

  onKeyPress = e => {
    if (e.key === 'Enter') {
      const { templates } = this.props;
      let suggestion = templates.filter(item => item.templateName === e.currentTarget.value);
      this.props.onChange({
        name: 'template',
        value: e.currentTarget.value,
        suggestion: { ...suggestion[0] },
      });
    }
  };

  render() {
    const { searchTerm, suggestions } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: this.props.placeholder || 'Search Template...',
      disabled: this.props.isDisabled || this.props.editStatus,
      value: searchTerm,
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      name: 'template',
      requires: 'true',
      type: 'text',
      className: 'form-control',
    };

    // Finally, render it!
    return (
      <div className={this.props.className || 'autocomplete-container'}>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getTemplateValue}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
          shouldRenderSuggestions={() => true}
          onSuggestionSelected={this.onTemplateSelected}
        />
      </div>
    );
  }
}

export default TemplateAutoComplete;